export default function () {
  const widgetName = 'spinningNumbers';
  const widgetOpts = spinningNumbersOpts;
  const wrapContainerClass = 'spinning-container';

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: true,
    maxItemsVisible: 6,
    itemsPerPanel: 6,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    slideshow: false,

    cardWidgetLoaded: function (data) {
      const itemsCount = data.items.length;

      if (itemsCount == 0) {
        $(`.${wrapContainerClass}`).remove();
      } else {
        createSpinnintNumbers(data);
      }
    },
  });
  function createSpinnintNumbers(data) {
    let countTo;

    $('<div class="sp-container animated"></div>').prependTo(`#${widgetName}`);
    $(`<div class="sp-wrapper"></div>`).appendTo('.sp-container');

    const items = data.items;

    let counter = 0;
    items.forEach(function (item) {
      let separatorElement = counter > 0 ? "<span class='separator'></span>" : '';
      const stat = `
      <div class="sp-block">
        <span class="spinning-text">${item.Description}</span>
        <span class="sp-value">${item.Title}</span>
        ${separatorElement}
      </div>`;
      $('.sp-wrapper').append(stat);
      counter++;
    });

    function formatNumber(num) {
      return num.toLocaleString();
    }

    function animateNumbers(el) {
      countTo = el.attr('data-countNum');
      $({ countNum: el.text() }).animate(
        {
          countNum: countTo,
        },
        {
          duration: 3000,
          easing: 'swing',
          step: function () {
            if (el.hasClass('decimal')) {
              el.text(formatNumber(Math.floor(this.countNum)));
            } else {
              el.text(Math.floor(this.countNum));
            }
          },
          complete: function () {
            if (el.hasClass('decimal')) {
              el.text(formatNumber(this.countNum));
            } else {
              el.text(this.countNum);
            }
          },
        },
      );
    }

    $(`#${widgetName} .sp-block`).each(function () {
      let title = $(this).find('.sp-value');
      let titleNumber = title.find('span');
      let titleNumberNum = title.find('span').text();
      titleNumber.text('0');
      titleNumber.addClass('js-countNum');
      titleNumber.attr('data-countNum', titleNumberNum);
    });

    let cw3 = $(`#${widgetName} .js-countNum`);
    let cw3top = cw3.offset().top;
    let animated = false;
    let vpBtm = $(window).scrollTop() + $(window).height();

    function triggerAnimation(p) {
      if (cw3top < p && !animated) {
        cw3.each(function () {
          animateNumbers($(this));
        });
        animated = true;
      }
    }

    triggerAnimation(vpBtm);

    $(window).scroll(function () {
      let vpBtm = $(window).scrollTop() + $(window).height();
      triggerAnimation(vpBtm);
    });

    $(`#${widgetName} .card-widget-item`).remove();
    $(`#${widgetName}`)
      .wrap(`<div class="${wrapContainerClass}"></div>`)
      .wrap('<div class="inner-container"></div>');
  }
}
